import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Circles } from 'react-loader-spinner';
import base_url from './api/Config';
import TopBar from './component/TopBar';
import authFetch from './api/authFetch';

const CustomerLoanList = () => {
  const [loans, setLoans] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const customerId = new URLSearchParams(location.search).get('customerId');

  useEffect(() => {
    if (!customerId) return;
    const fetchLoans = async () => {
      setIsLoading(true);
      try {
        const res = await authFetch(`${base_url}/api/loan/viewByCustomerId?customerId=${customerId}`);
        if (!res.ok) throw new Error('Failed to fetch loans');
        setLoans(await res.json());
      } catch (err) {
        setError(err.message || 'Something went wrong');
      } finally {
        setIsLoading(false);
      }
    };
    fetchLoans();
  }, [customerId]);

  const getStatusBadge = (status) => {
    if (!status) return <span className="status-badge badge-blue">N/A</span>;
    if (status === 'Active') return <span className="status-badge badge-green">Active</span>;
    if (status === 'Closed') return <span className="status-badge badge-blue">Closed</span>;
    return <span className="status-badge badge-orange">{status}</span>;
  };

  return (
    <div className="app-page">
      <TopBar title="Loan List" backPath="/Home" />

      <div className="app-content">
        {isLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 60 }}>
            <Circles height={60} width={60} color="#1d2e77" />
          </div>
        ) : error ? (
          <div className="app-card" style={{ color: '#e53935', textAlign: 'center' }}>{error}</div>
        ) : loans.length === 0 ? (
          <div className="app-card" style={{ textAlign: 'center', color: '#888' }}>No loans found.</div>
        ) : (
          loans.map((loan, i) => (
            <div key={i} className="list-card" onClick={() => navigate(`/RepaymentList?loanId=${loan.id}`)}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <p style={{ fontSize: 18, fontWeight: 700, color: '#1d2e77', marginBottom: 4 }}>
                    ₹{loan.loanAmount?.toLocaleString()}
                  </p>
                  <p style={{ fontSize: 13, color: '#666', marginBottom: 2 }}>Loan ID: <strong>#{loan.id}</strong></p>
                  <p style={{ fontSize: 13, color: '#666', marginBottom: 2 }}>Tenure: <strong>{loan.tenure} days</strong></p>
                  <p style={{ fontSize: 13, color: '#666', marginBottom: 0 }}>Processing Fee: <strong>₹{loan.processingFee}</strong></p>
                </div>
                <div style={{ textAlign: 'right' }}>
                  {getStatusBadge(loan.status)}
                  <p style={{ fontSize: 13, color: '#666', marginTop: 8 }}>
                    Disbursed: <strong>₹{loan.disbursedAmount}</strong>
                  </p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CustomerLoanList;
